import React from 'react';
import { LuSearch } from 'react-icons/lu';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Rótulo para leitor de tela, quando o placeholder não basta. */
  label?: string;
  disabled?: boolean;
  /** Fixa logo abaixo do cabeçalho ao rolar (listas longas). */
  sticky?: boolean;
  /** Enter na busca (ex.: adicionar o primeiro resultado). */
  onEnter?: () => void;
}

/** Busca que filtra a lista enquanto digita. */
export const SearchField: React.FC<SearchFieldProps> = ({ value, onChange, placeholder, label, disabled, sticky = false, onEnter }) => (
  <div className={sticky ? "sticky top-below-header z-10 -my-1.5 bg-surface py-1.5" : undefined}>
    <div className="relative">
      <LuSearch size={20} aria-hidden className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-fg-subtle" />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== "Enter" || !onEnter) return;
          e.preventDefault();
          onEnter();
        }}
        placeholder={placeholder}
        aria-label={label ?? placeholder}
        disabled={disabled}
        className="h-12 w-full rounded-button border border-line-strong bg-surface pl-12 pr-4 text-body text-fg placeholder:text-fg-subtle focus:border-primary focus:outline-none focus:shadow-focus disabled:bg-surface-muted"
      />
    </div>
  </div>
);
